/** @format */

// services/dirService.js

import registry from './dirRegistry';

export async function loadDir({ name, axios, store }) {
  const config = registry[name];
  console.log('load dir', name);
  if (!config) {
    console.warn(`Dir not found: ${name}`);
    return [];
  }

  let data = [];

  if (config.custom) {
    data = await config.custom({ store, axios });
  } else {
    const method = config.method || 'get';
    const resp = await axios({
      method,
      url: config.url,
      params: config.params,
      data: config.body,
    });
    if (resp.data.status === 'ok') {
      data = resp.data.data;
    }
  }

  if (config.transform) {
    data = config.transform(data);
  }
  return data || [];
}
export async function loadDirById({ name, id, axios, store }) {
  const config = registry[name];
  if (!config?.byId) return null;

  const resp = await axios.get(config.byId(id));
  if (resp.data.status !== 'ok') return null;

  let data = resp.data.data;

  // нормализуем в массив
  if (!Array.isArray(data)) data = [data];

  if (config.transform) {
    data = config.transform(data);
  }

  return data[0] || null;
}
